import availableFlowIds from 'src/config/availableFlowIds.json';
import { buildValidFlowPath } from 'src/viewLayer/helpers/pathHelpers';
import { PathParams } from 'src/types/pathHelpers';
import type { Navigate } from 'src/types/navigate';

type GoToNextNodeArgs = PathParams & { navigate: Navigate };

export const isFlowAvailable = (destination: string): boolean =>
  availableFlowIds.includes(destination);

export const getFlowProgress = (flowLength: number, nodeNumber: number): {
  currentFlowStep: number,
  flowLength: number
} => ({
  currentFlowStep: nodeNumber + 1,
  flowLength
});

export const goToNextNode = ({
  environment,
  learnLang,
  flowId,
  nodeNumber,
  queryParams,
  navigate
}: GoToNextNodeArgs): void =>
  navigate(
    buildValidFlowPath({ environment, learnLang, flowId, nodeNumber: nodeNumber + 1, queryParams })
  );
